import React from 'react';

const CreateBetaGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="#FEFEFE" d="M28.833 110.789h86.334v-83.25H28.833z" />
            <path
                d="M29.604 110.018h84.792V28.31H29.604v81.708zm-1.541 1.542h87.874V26.768H28.064v84.792z"
                fill="#6A6B6E"
            />
            <path fill="#F26932" d="M38.083 72.247h67.834V49.122H38.083z" />
            <path
                d="M38.854 71.476h66.292V49.893H38.854v21.583zm-1.541 1.542h69.374V48.351H37.314v24.667z"
                fill="#6A6B6E"
            />
            <path
                d="M30.375 109.247h83.25V29.08h-83.25v80.167zm-3.083 3.083h89.416V25.997H27.292v86.333z"
                fill="#363A43"
            />
            <path
                fill="#363A43"
                d="M28.833 41.414h86.334V38.33H28.833zM33.458 35.247h3.084v-3.083h-3.084zM39.625 35.247h3.083v-3.083h-3.083zM45.792 35.247h3.083v-3.083h-3.083z"
            />
            <path
                fill="#363A43"
                d="M51.958 39.872h3.084V27.54h-3.084zM58.125 35.247h52.417v-3.083H58.125zM39.625 70.705h64.75V50.664h-64.75v20.041zm-3.083 3.084h70.916V47.58H36.542V73.79zM69 94.083h15.333V91H69zM69 100.083h37.187V97H69zM69 88.083h37.187V85H69z"
            />
            <path
                d="M80.738 66.338H63.262l7.827-8.53 4.266 4.648.91-.993 4.473 4.875zm-2.604-7.334a2.5 2.5 0 1 1-.001-5 2.5 2.5 0 0 1 .001 5z"
                fill="#FEFEFE"
            />
            <path
                fill="#363A43"
                d="M34.787 106.479l-2.18-2.18 10.98-10.98 2.18 2.18z"
            />
            <path
                d="M38.394 92.224l6.515.544a1.54 1.54 0 0 1 1.408 1.408l.508 6.096 2.549-5.607a1.52 1.52 0 0 1 1.679-.878l5.502 1-3.796-3.32a1.543 1.543 0 0 1-.365-1.845l2.884-5.815-5.815 2.883c-.629.31-1.384.16-1.845-.366l-3.87-4.423.569 6.265a1.544 1.544 0 0 1-.846 1.52l-5.077 2.538zm7.388 15.614a1.544 1.544 0 0 1-1.539-1.414l-.891-10.693-10.693-.89a1.54 1.54 0 0 1-.561-2.914l9.054-4.528-.905-9.946a1.542 1.542 0 0 1 2.695-1.154l6.214 7.1 8.851-4.387a1.536 1.536 0 0 1 1.776.29c.467.469.584 1.182.291 1.776l-4.39 8.85 7.102 6.213a1.541 1.541 0 0 1-1.29 2.677l-9.813-1.784-4.5 9.9a1.541 1.541 0 0 1-1.401.904z"
                fill="#363A43"
            />
            <path
                fill="#D2D6DF"
                d="M13.799 121.288L32.787 102.3l3.998 3.997-18.989 18.989z"
            />
            <path
                d="M15.979 121.289l1.817 1.817 16.81-16.81-1.819-1.816-16.808 16.809zm1.817 6.177l-6.177-6.177 21.168-21.17 6.178 6.177-21.169 21.17zM60.763 90.853c-.2 0-.4-.047-.586-.124a1.348 1.348 0 0 1-.493-.339 1.466 1.466 0 0 1-.447-1.079c0-.217.03-.402.108-.603.077-.185.2-.353.339-.492.57-.57 1.603-.57 2.174 0a1.505 1.505 0 0 1 0 2.174 1.54 1.54 0 0 1-1.095.463M38.779 86.843c-.401 0-.802-.154-1.08-.447a1.535 1.535 0 0 1-.462-1.094c0-.401.17-.802.462-1.078.57-.587 1.604-.587 2.174 0 .293.276.447.677.447 1.078 0 .418-.154.803-.447 1.094a1.476 1.476 0 0 1-1.094.447M50.773 80.862c-.4 0-.801-.168-1.094-.463a1.592 1.592 0 0 1-.447-1.094c0-.401.17-.802.447-1.08.585-.57 1.618-.57 2.189 0 .293.278.447.679.447 1.08 0 .416-.154.801-.447 1.094a1.534 1.534 0 0 1-1.095.463M54.782 101.845c-.216 0-.417-.047-.602-.124a1.348 1.348 0 0 1-.493-.339 1.361 1.361 0 0 1-.34-.493 1.52 1.52 0 0 1-.107-.586c0-.418.154-.803.447-1.095.57-.57 1.603-.57 2.174 0 .293.292.462.677.462 1.095 0 .2-.046.4-.123.586a1.361 1.361 0 0 1-.34.493 1.348 1.348 0 0 1-.492.34 1.535 1.535 0 0 1-.586.123"
                fill="#363A43"
            />
            <path
                d="M38.394 92.224l6.515.544a1.54 1.54 0 0 1 1.408 1.408l.508 6.096 2.549-5.607a1.52 1.52 0 0 1 1.679-.878l5.502 1-3.796-3.32a1.543 1.543 0 0 1-.365-1.845l2.884-5.815-5.815 2.883c-.629.31-1.384.16-1.845-.366l-3.87-4.423.569 6.265a1.544 1.544 0 0 1-.846 1.52l-5.077 2.538z"
                fill="#FFF"
            />
            <path d="M0 0h144v144H0z" />
        </g>
    </svg>
);

CreateBetaGraphicSvg.displayName = 'CreateBetaGraphicSvg';
export default CreateBetaGraphicSvg;
